import Component from '@component';
import Device from '@utils/html/Device';

export default class ClickPush extends Component {
	onInit(el) {
		this.el = el;

		const elJson = this.el.querySelectorAll('.js-gtm-json');
		elJson.forEach((element) => {
			this.json = !!element ? JSON.parse(element.textContent) : null;

			if (this.json == void 0) {
				this.onDestroy();
				return false;
			}
		});
		this.bindEvents();
	}

	bindEvents() {
		this.el.addEventListener(Device.click, this.onClick.bind(this));
	}

	onClick() {
		window.dataLayer.push(this.json);
	}
}
